import axios from 'axios';

export const fetchLineLogisticsFailedOrders = (brandId: number) =>
  axios.get(`/api/line/brands/${brandId}/orders/delivery-failed`);
